/**
 * Pièces saisies avant que leur document n'existe en base.
 *
 * <p>Les formulaires d'un devis ou d'une facture neufs proposent, comme la
 * maquette, de joindre tout de suite une facture fournisseur ou une photo. Le
 * document n'a pas encore d'identifiant serveur : les pièces attendent ici,
 * sous son genre et son numéro, que la synchronisation l'ait créé ; la fiche du
 * document les dépose alors.
 *
 * <p>L'attente vit le temps de la page : un rechargement avant la création du
 * document les perd, comme il perdrait le document lui-même.
 */
const attente = new Map();

const cle = (numero, genre) => genre + ':' + String(numero);

/**
 * @param {string|number} numero numéro du document (pas son identifiant)
 * @param {object[]} pieces pièces à déposer
 * @param {'DEVIS'|'FACTURE'} [genre] genre du document
 */
export function metEnAttente(numero, pieces, genre = 'DEVIS') {
  if (numero == null || !pieces || pieces.length === 0) {
    return;
  }
  const k = cle(numero, genre);
  attente.set(k, [...(attente.get(k) || []), ...pieces]);
}

/**
 * @param {string|number} numero numéro du document
 * @param {'DEVIS'|'FACTURE'} [genre] genre du document
 * @returns {object[]} les pièces en attente, sans les retirer
 */
export function enAttente(numero, genre = 'DEVIS') {
  return numero == null ? [] : attente.get(cle(numero, genre)) || [];
}

/**
 * Retire et rend les pièces en attente d'un document.
 *
 * @param {string|number} numero numéro du document
 * @param {'DEVIS'|'FACTURE'} [genre] genre du document
 * @returns {object[]} les pièces, à déposer
 */
export function prendEnAttente(numero, genre = 'DEVIS') {
  if (numero == null) {
    return [];
  }
  const k = cle(numero, genre);
  const pieces = attente.get(k) || [];
  attente.delete(k);
  return pieces;
}
